import {Component} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MessageService} from 'primeng/api';
import {GenericResponse} from '@app/core/backend';
import {PageComponent} from '@app/modules/shared/components/page/page.component';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonDirective} from 'primeng/button';
import {Ripple} from 'primeng/ripple';
import {DatePipe, Location} from '@angular/common';
import {DropdownModule} from "primeng/dropdown";
import {SystemUserService} from "@app/modules/admin/system-user/system-user.service";
import {UserProfile, UserProfileRequest} from "@app/modules/admin/model/system-user.model";
import {InputSwitchModule} from "primeng/inputswitch";
import {PasswordModule} from "primeng/password";
import {DataDisplayComponent} from "@app/modules/shared/components/data-display/data-display.component";
import {AuthService} from "@app/core/auth";
import {AvatarModule} from "primeng/avatar";
import {ChangePasswordComponent} from "@app/modules/admin/system-user/change-password/change-password.component";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import { ConfirmModalComponent } from "@app/modules/shared/components/confirm-modal/confirm-modal.component";
import {
  DataListDisplayModalComponent
} from "@app/modules/shared/components/data-list-display-modal/data-list-display-modal.component";

@Component({
  selector: 'app-profile',

  imports: [
    ReactiveFormsModule,
    PageComponent,
    InputTextModule,
    ButtonDirective,
    Ripple,
    DropdownModule,
    InputSwitchModule,
    PasswordModule,
    DataDisplayComponent,
    AvatarModule,
    DatePipe
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {
  id!: string;
  title!: string | null;
  buttonTitle!: string | null;
  submitButtonPressed = false;
  username!: string;
  user!: UserProfile;

  ref: DynamicDialogRef | undefined;

  constructor(
    private readonly messageService: MessageService,
    private readonly userService: SystemUserService,
    private readonly location: Location,
    private readonly authService: AuthService,
    public readonly dialogService: DialogService
  ) {
  }

  ngOnInit() {
    this.authService.user$.subscribe((user) => {
      // this.username = user.username; //VAPT Disallowed
    });
    this.fetchUser();
  }

  fetchUser() {
    const userProfileRequest: UserProfileRequest = {
      username: this.username
    }

    this.userService.fetchUserProfile(userProfileRequest).subscribe({
      next: response => {
        this.user = response.data;
      },
      error: (errorResponse: any) => {
        let errorData: GenericResponse<any> = errorResponse.error;
        this.submitButtonPressed = false;
        if (errorResponse && errorData?.message) {
          this.messageService.add({
            key: 'message',
            severity: 'error',
            summary: 'User Fetch Error',
            detail: errorData.message
          });
        } else {
          this.messageService.add({
            key: 'message',
            severity: 'error',
            summary: 'User Fetch Error',
            detail: 'Failed to fetch user'
          });
        }
      }
    });
  }


  goBack() {
    this.location.back();
  }

  getUserInitials(): string {
    const firstNameInitial = this.user?.firstName ? this.user.firstName.charAt(0) : '';
    const lastNameInitial = this.user?.lastName ? this.user.lastName.charAt(0) : '';
    return firstNameInitial + lastNameInitial;
  }

  openChangePasswordPage(username: string | null | undefined) {
    // if (username) {
      this.ref = this.dialogService.open(ChangePasswordComponent, {
        data: username,
        header: 'Change Password',
        width: '50%',
        contentStyle: {overflow: 'auto'},
        baseZIndex: 10000,
        maximizable: true,
        modal: true,
        closable: true
      });
    // }

  }

  showBranches() {
    let branchDisplayFields: { key: string; label: string }[] = [
      { key: "name", label: "Branch Name" },
      { key: "code", label: "Branch Code" },
      { key: "location", label: "Location" },
      { key: "phoneNumber", label: "Phone Number" },
      { key: "fax", label: "Fax" },
      { key: "status", label: "Status" },
    ];

    this.dialogService.open(DataListDisplayModalComponent, {
      data: {
        data: this.user?.branches ?? [],
        displayFields: branchDisplayFields,
      },
      header: "Accessible Branches",
      width: "70%",
      contentStyle: { overflow: "auto" },
      baseZIndex: 10000,
      modal: true,
      closable: true,
      maximizable: true,
    });
  }
}
